import { useState, useEffect } from "react";
import axios from "../../../config/axios/axios";
import EmailVerified from "../../components/verification/email-verified";
import NoToken from "../../components/verification/no-token";
import useQuery from "../../../shared/functions/functions";
import { Redirect } from "react-router-dom";

function VerifyEmailBusiness() {
  const [emailNotVerified, setEmailNotVerified] = useState(true);
  const query = useQuery();
  const verificationToken = query.get("verificationToken");
  const [token] = useState(verificationToken);

  useEffect(() => {
    sendVerifyEmailRequest(token);
  }, []);

  if (!token) {
    return returnNoTokenProvided();
  }

  if (emailNotVerified) {
    return (
      <div>
        <NoToken />
      </div>
    );
  }

  return (
    <div>
      <EmailVerified />
    </div>
  );

  function sendVerifyEmailRequest(token) {
    axios
      .post(`client/business/verify-email`, { token: token })
      .then((response) => {
        setEmailNotVerified(false);
      })
      .catch((error) => {
        setEmailNotVerified(true);
      });
  }
}

function returnNoTokenProvided() {
  return (
    <div>
      <Redirect to={"/page-not-found"} />
    </div>
  );
}

export default VerifyEmailBusiness;
